export default function enabledisablemonitorReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'ENABLE_OR_DISABLE_MONITOR_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'ENABLE_OR_DISABLE_MONITOR_ERROR':
            return {...state, ...{error: action.error}};

        case 'ENABLE_OR_DISABLE_MONITOR_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}